export const COLORS = [
  { rgb: [46, 39, 248], hex: '#2e27f8' },
  { rgb: [72, 149, 239], hex: '#4895ef' },
  { rgb: [250, 163, 7], hex: '#faa307' },
  { rgb: [220, 47, 2], hex: '#dc2f02' },
  { rgb: [181, 23, 158], hex: '#b5179e' }
]
